import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const addCreditsForOrg = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'ADDING_CREDITS_FOR_ORGS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(`/ads/credits/add`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'ADDING_CREDITS_FOR_ORGS_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'ADDING_CREDITS_FOR_ORGS_FAILED',
              payload: `Failed to update credits`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'ADDING_CREDITS_FOR_ORGS_FAILED',
            payload: `Failed to update credits`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'ADDING_CREDITS_FOR_ORGS_FAILED',
        payload: `Failed to update credits`,
      });
    }
  };
};

export default addCreditsForOrg;
